import { put, select, takeEvery } from 'redux-saga/effects';
import isEqual from 'lodash/isEqual';

import { IScreenInfo } from '@pressreader/ui-types';

import { computeScreenInfo } from '../utils/common';

import { notifyScreenReaderAction, screenChanged, screenReaderNotified, screenResized, topbarHeightChanged } from './actions';
import { selectScreenInfo } from './selectors';

function computeActualScreenInfo(
    prevScreen: IScreenInfo,
    options?: {
        newHeaderHeight?: number;
    },
): IScreenInfo {
    let { headerHeight } = prevScreen;

    if (options?.newHeaderHeight) {
        headerHeight = options.newHeaderHeight;
    }

    const newScreen = computeScreenInfo();
    const viewport = {
        top: headerHeight,
        left: 0,
        width: newScreen.availWidth,
        height: newScreen.availHeight - headerHeight,
    };

    return { ...newScreen, headerHeight, viewport };
}

function* handleScreenChange(prevScreen: IScreenInfo, newScreen: IScreenInfo) {
    if (!isEqual(prevScreen, newScreen)) {
        yield put(screenChanged({ prevScreen, screen: newScreen }));
    }
}

function* changeScreen() {
    const prevScreen: ReturnType<typeof selectScreenInfo> = yield select(selectScreenInfo);
    const newScreen = computeActualScreenInfo(prevScreen);

    yield handleScreenChange(prevScreen, newScreen);
}

function* changeTopbarHeight(action: ReturnType<typeof topbarHeightChanged>) {
    const topbarHeight = action.payload.topbarHeight;

    const prevScreen: ReturnType<typeof selectScreenInfo> = yield select(selectScreenInfo);
    const newScreen = computeActualScreenInfo(prevScreen, { newHeaderHeight: topbarHeight });

    yield handleScreenChange(prevScreen, newScreen);
}

function* notifyScreenReader(action: ReturnType<typeof notifyScreenReaderAction>) {
    yield put(screenReaderNotified({ message: action.payload.message }));
}

function* saga() {
    yield takeEvery(screenResized, changeScreen);

    yield takeEvery(topbarHeightChanged, changeTopbarHeight);

    yield takeEvery(notifyScreenReaderAction, notifyScreenReader);
}

export { saga };
